import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import VerticalLayout from "components/VerticalLayout";
import HorizontalLayout from "components/HorizontalLayout";
import {useEffect} from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
//import { BASE_URL} from "../../global";
//constants
import { layoutTypes } from "../../constants/layout";
import { SECURITY_KEY, BASE_URL } from "../../global";
import { AuthenticatedPlainLayout } from "../../components/AuthenticatedPlainLayout/AuthenticatedPlainLayout";
import { IframeContentViewReporter } from "../../modules/online-lesson/IframeContentViewReporter";
import AnniversaryOverlay from "../../pages/Utility/AnniversaryOverlay";
import PaymentHoldNotice from "../../components/PaymentHoldNotice";
const Authmiddleware = (props) => {

  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }));

  const getLayout = (layoutType) => {
    let Layout = VerticalLayout;
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout;
        break;
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout;
        break;
      default:
        break;
    }

    if(props.layout?.plainLayout) {
      Layout = AuthenticatedPlainLayout
    }

    return Layout;
  };

  const Layout = getLayout(layoutType);

  const location = useLocation();
  const navigate = useNavigate();
  const authUser = JSON.parse(localStorage.getItem('authStudentUser')) || null;
  //console.log(location);
// console.log(tutor_key.pk_tut_key);
 useEffect(() => {
    if (authUser && authUser != "" && authUser != null) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${authUser}` 
      axios.get(BASE_URL+'studentlogin/checkUser').then(responseStudent => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
           
              if (responseStudent.data.length > 0) {
                    if (responseStudent.data[0]['pk_student_key'] !== '') {
                      
                      localStorage.setItem("userprofile", responseStudent.data[0]["st_profile_avatar"])
                      localStorage.setItem("userskintone", responseStudent.data[0]["st_skintone"])
                      localStorage.setItem("usergender", responseStudent.data[0]["st_gender"])
                      localStorage.setItem("is_leaderboard", responseStudent.data[0]["is_leaderboard"])
                      localStorage.setItem("is_fontsize", responseStudent.data[0]["is_fontsize"])
                      localStorage.setItem("st_fontsize", responseStudent.data[0]["st_fontsize"])
                      localStorage.setItem("is_trial", responseStudent.data[0]["cent_is_trial_account"])
                      const fontSize = responseStudent.data[0]["st_fontsize"] && parseInt(responseStudent.data[0]["st_fontsize"])
                          ? parseInt(responseStudent.data[0]["st_fontsize"])
                          : 20;

                        const sB = responseStudent.data[0]["show_birthday"] ? "1" : "0";
                        const sA = responseStudent.data[0]["show_anniversary"] ? "1" : "0";
                        if ((sB == "1" || sA == "1")) {
                          localStorage.setItem("show_birthday", sB);
                          localStorage.setItem("show_anniversary", sA);
                          localStorage.setItem("celebration_age", responseStudent.data[0]["celebration_age"] ?? "");
                          localStorage.setItem("celebration_years", responseStudent.data[0]["celebration_years"] ?? "");
                          window.dispatchEvent(new Event("celebration-check"));
                        }

                        document.documentElement.style.setProperty("--custom-font-size", `${fontSize}px`);
                        if (location.pathname == "/manual-lcms-worksheet" || 
                          location.pathname == "/manual-lcms-worksheet-answer" ||
                          location.pathname !== "/manual-worksheet" ||
                          location.pathname !== "/manual-assessment" ||
                          location.pathname !== "/assessment-details" ||
                          location.pathname !== "/diagnostic-details") {
                          console.log("You are on the homework list page");
                        }else{
                          localStorage.removeItem("authTutorUser")
                        }
                        
                  } else {
                    localStorage.clear();
                    <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
                  }

              }else{
                localStorage.clear();
                <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
              }
            
        })
        .catch(error => {
          console.log(error)
          if ((error?.response?.status === 403 || error?.response?.status === 401)) {
            toast.error("Your authentication has expired. Please log in again.", {
              autoClose: 3000, // 3 seconds in this example
              onClose: () => {
                localStorage.clear();
                navigate("/login");
              },
            })
          }

          // if(error){
          //   localStorage.clear();
          // <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
          // }
          
        });


    }
    else{
      localStorage.clear();
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    }
   

}, [props.children]);


  if (!localStorage.getItem("authStudentUser")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return (
    <React.Fragment>
      <IframeContentViewReporter />
      <PaymentHoldNotice />
      <Layout>{props.children}</Layout>
        {/* Mounted once here (not in Layout.js) so it covers every
          authenticated route regardless of which layout variant
          (Vertical/Horizontal/PlainLayout) gets picked for that page. */}
      <AnniversaryOverlay />
    </React.Fragment>);
};

export default Authmiddleware;
